import React, { useState, useContext } from "react";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import Select from "react-select";
import NumUsersDisplay from "../../../../components/wifi/NumUsersDisplay";
import useAuth from "../../../../hooks/useAuth";
import axios from "axios";
import { apiConfig } from "../../../../config";
import NotyfContext from "../../../../contexts/NotyfContext";

const MigrateUsersBetweenAccounts = ({
  openModals,
  toggle,
  customerOptions,
  dispatch,
  setRefreshData,
}) => {
  const notyf = useContext(NotyfContext);
  const [type] = useState("success");
  const [duration] = useState("30000");
  const [ripple] = useState(true);
  const [dismissible] = useState(true);
  const [positionX] = useState("right");
  const [positionY] = useState("top");
  const { userAccessToken } = useAuth();
  const bearerToken = `Bearer ${userAccessToken}`;
  const [fromExcellId, setFromExcellId] = useState();
  const [toExcellId, setToExcellId] = useState();
  const [fromNumUsersIsLoading, setFromNumUsersIsLoading] = useState(true);
  const [fromNumAvailable, setFromNumAvailable] = useState(0);
  const [fromNumInUse, setFromNumInUse] = useState(0);
  const [toNumUsersIsLoading, setToNumUsersIsLoading] = useState(true);
  const [toNumAvailable, setToNumAvailable] = useState(0);
  const [toNumInUse, setToNumInUse] = useState(0);

  const isCredentialFormComplete =
    fromExcellId &&
    toExcellId &&
    fromNumInUse > 0 && // from account must have users in use
    toNumAvailable > 0 && // to account must have available quota
    toNumAvailable >= fromNumInUse; // to account must have enough quota for the migration

  const resetFormFields = () => {
    setFromExcellId(null);
    setToExcellId(null);
  };

  const handleMigrateCredentialSubmit = (event) => {
    event.preventDefault();
    const migrateCredentialBody = {
      old_symbill_id: fromExcellId,
      new_symbill_id: toExcellId,
    };
    const axiosConfig = {
      headers: { Authorization: bearerToken },
    };
    axios
      .post(
        apiConfig.dot11ApiUrl + "users/migrate",
        migrateCredentialBody,
        axiosConfig
      )
      .then(function (response) {
        if (response.data.success === 1) {
          notyf.open({
            type,
            message: response.data.message,
            duration,
            ripple,
            dismissible,
            position: {
              x: positionX,
              y: positionY,
            },
          });
        } else {
          notyf.open({
            type: "warning",
            message: response.data.error || "Unknown error occurred",
            duration,
            ripple,
            dismissible,
            position: {
              x: positionX,
              y: positionY,
            },
          });
        }
      })
      .catch(function (error) {
        notyf.open({
          type: "warning",
          message: error.response.data.error,
          duration,
          ripple,
          dismissible,
          position: {
            x: positionX,
            y: positionY,
          },
        });
      });
  };
  return (
    <Modal
      show={openModals["migrateCredentials"]}
      onHide={() => {
        toggle("migrateCredentials");
        resetFormFields();
      }}
      centered
    >
      <Form onSubmit={handleMigrateCredentialSubmit}>
        <Modal.Header closeButton>
          <b>Admin Function:</b>&nbsp; Migrate Credentials Between Accounts
        </Modal.Header>
        <Modal.Body className="m-3">
          <div className="text-left my-0">
            <Form.Group className="mb-3">
              <h3>Select an account to migrate wi-fi users from:</h3>
              <Form.Label>Migrate From Company Name</Form.Label>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={customerOptions}
                onChange={(e) => {
                  setFromExcellId(e.value);
                  setToExcellId(null);
                }}
                value={
                  fromExcellId
                    ? customerOptions.find(
                        (option) => option.value === fromExcellId
                      )
                    : null
                }
              />
            </Form.Group>
            {fromExcellId ? (
              <NumUsersDisplay
                excellid={fromExcellId}
                isLoading={fromNumUsersIsLoading}
                setIsLoading={setFromNumUsersIsLoading}
                numAvailable={fromNumAvailable}
                setNumAvailable={setFromNumAvailable}
                numInUse={fromNumInUse}
                setNumInUse={setFromNumInUse}
              />
            ) : null}
            {!fromNumUsersIsLoading && fromNumInUse > 0 && (
              <>
                <hr />
                <Form.Group className="mb-3">
                  <h3>Select an account to migrate wi-fi users to:</h3>
                  <Form.Label>Migrate To Company Name</Form.Label>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={customerOptions}
                    onChange={(e) => {
                      setToExcellId(e.value);
                    }}
                    value={
                      toExcellId
                        ? customerOptions.find(
                            (option) => option.value === toExcellId
                          )
                        : null
                    }
                  />
                </Form.Group>
                {toExcellId ? (
                  <NumUsersDisplay
                    excellid={toExcellId}
                    isLoading={toNumUsersIsLoading}
                    setIsLoading={setToNumUsersIsLoading}
                    numAvailable={toNumAvailable}
                    setNumAvailable={setToNumAvailable}
                    numInUse={toNumInUse}
                    setNumInUse={setToNumInUse}
                  />
                ) : null}
              </>
            )}

            {!toNumUsersIsLoading && (
              <>
                {fromNumInUse <= 0 && (
                  <Alert className="my-3 p-2">
                    This account has no users in use, so migration is not
                    possible.
                  </Alert>
                )}
                {toNumAvailable <= 0 && (
                  <Alert className="my-3 p-2">
                    This account has 0 "Available" wi-fi user quota to allow the
                    migration.
                  </Alert>
                )}
                {toNumAvailable < fromNumInUse && (
                  <Alert className="my-3 p-2">
                    This account has less than {fromNumInUse} "Available" wi-fi
                    user quota to allow the migration.
                  </Alert>
                )}
                {toNumAvailable >= fromNumInUse && toExcellId && (
                  <Alert className="mt-4 mb-0 p-2" variant="success">
                    This account has enough "Available" wi-fi user quota to
                    allow the migration. Click "Migrate Credentials" to proceed.
                  </Alert>
                )}
              </>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => toggle("migrateCredentials")}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="info"
            disabled={!isCredentialFormComplete}
            onClick={() => {
              toggle("migrateCredentials");
              setTimeout(() => dispatch(setRefreshData()), 2000);
            }}
          >
            Migrate Credentials
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default MigrateUsersBetweenAccounts;
